<template>
  <div class="dialog">
    <div class="login-page">
      <el-card class="box-card">
        <h1>教师证书管理系统登录</h1>
        <el-form status-icon :model="formName" :rules="rules2" ref="formName">
          <el-form-item prop="user">
            <el-input type="text" id="user" v-model="formName.user"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" id="password" v-model="formName.password"></el-input>
          </el-form-item>
          <el-button type="primary" @click="submitForm('formName')" v-bind:disabled="formName.beDisabled">提交</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form>
      </el-card>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  export default {
    name: 'Login',
    data() {
      var check_user = (rule, value, callback) => {
        if (value === '') {
          return callback(new Error('用户不能为空'));
        } else {
          if (this.formName.user != '' && this.formName.password != '') {
            this.formName.beDisabled = false;
          } else {
            this.formName.beDisabled = true;
          }
          callback();
        }
      };
      var check_pass = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('密码不能为空'));
        } else {
          if (this.formName.user != '' && this.formName.password != '') {
            this.formName.beDisabled = false;
          } else {
            this.formName.beDisabled = true;
          }
          callback();
        }
      };
      return {
        formName: {
          user: '',
          password: '',
          beDisabled: true
        },
        beShow: false,
        rules2: {
          user: [{
            validator: check_user,
            trigger: 'blur'
          }],
          password: [{
            validator: check_pass,
            trigger: 'blur'
          }],
        }
      }
    },
    mounted: function() {
      this.checkLogin()
    },
    methods: {
      checkLogin(){
        console.log(localStorage.getItem('authorization'))
        if(localStorage.getItem('authorization')){
          this.$router.push('/dashboard');
        }else{

        }
      },
      resetForm: function() {
        this.formName.user = '';
        this.formName.password = '';
      },
      submitForm: function(formName) {
        var user = this.formName.user;
        var password = this.formName.password;
        let fd = new FormData()
        fd.append('username', user)
        fd.append('password', password)
        this.$http.post('http://120.27.221.176/backend/api/v1/login/', fd, {credentials : true})
          .then((response) => {
            console.log(response)
            if (response.status === 200) {
              this.$message({message:'登录成功', type: 'success'});
              localStorage.setItem('username', this.formName.user);
              localStorage.setItem('authorization', "Bearer " + response.data.token);
              this.$router.push('/dashboard');
            } else {
              this.$message.error('登录失败，请重试');
            }
          }, (response) => {
            this.$message.error('账户名或者密码错误');
          });
      }
    }
  }
</script>
<style scoped>
  html,
  body {
    margin: 0;
    padding: 0;
    position: relative;
  }

  .dialog {
    width: 100%;
    height: 100%;
    text-align: center;
  }

  .a {
    height: 53px;
    width: 100%;
    line-height: 52px;
    font-size: 22px;
    font-weight: bold;
    color: #fff;
    background-color: #5BB64D;
    text-align: center;
    display: block;
    text-decoration: none;
  }

  .box-card {
    width: 500px;
    margin:0 auto;
    margin-top: 150px;
    text-align: center;
    border-radius: 5px;
  }

  .label {
    text-decoration: none;
    font-size: 16px;
    font-weight: bold;
    width: 100%;
    margin-top: 10px;
    border-radius: 5px;
  }

  .button:hover {
    color: #fff;
    background-color: #1C3717;
    text-decoration: none;
  }

  h1 {
    text-align: center;
  }

  img {
    width: 96px;
    border: 1;
    object-fit: fill;
    border-radius: 5px;
    border-color: rgba(103,194,58,.2);
  }

  .input {
    padding: 30px;
    text-align: center;
  }

  .avater {
    padding: 15px;
    text-align: center;
    overflow: hidden;
  }

  .item {
    margin-tip: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue